import { Globals } from "./Globals";
/**
 * Provides an interface to the HTML5 peformance API that is polyfilled for Node
 */

const mockTiming = {
	navigationStart: Date.now(),
};

export const Performance = {
	now: () => (Globals.performance ? Globals.performance?.now() : Date.now()),
	timing: Globals.performance?.timing ? Globals.performance.timing : mockTiming,
};
